module.exports = __webpack_public_path__ + "media/images/star_02-c393039cbefaa80ff1c50a4be0f8052d.svg";